import { AuthenticatedRoute } from 'components/AuthenticatedRoute/AuthenticatedRoute'
import { LaunchDarklyDependentContent } from 'components/LaunchDarklyDependentContent/LaunchDarklyDependentContent'
import { Error404 } from 'Error404'
import { FC } from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'

import { PremiumsBills } from './pages/PremiumsBills'
import { PremiumsMonthly } from './pages/PremiumsMonthly'
import { EasyPayEditPage } from './pages/EasyPay/EasyPayEditPage'
import { EasyPayEditSubmittedPage } from './pages/EasyPay/EasyPayEditSubmittedPage'
import { EasyPaySignupPage } from './pages/EasyPay/EasyPaySignupPage'
import { EasyPaySignupSubmitted } from './pages/EasyPay/EasyPaySignupSubmitted'
import { EasyPayStopPage } from './pages/EasyPay/EasyPayStopPage'
import { EasyPayStopSuccessPage } from './pages/EasyPay/EasyPayStopSuccessPage'

export const PremiumsSwitch: FC = () => {
  const match = useRouteMatch()
  const matchedPath = match.path

  const routes = {
    premiumBills: `${matchedPath}/bills`,
    premiumMonthly: `${matchedPath}/monthly`,
    EasyPaySignupPage: `${matchedPath}/easy-pay/signup`,
    EasyPaySignupSubmitted: `${matchedPath}/easy-pay/signup/submitted`,
    EasyPayEditPage: `${matchedPath}/easy-pay/edit`,
    EasyPayEditSubmittedPage: `${matchedPath}/easy-pay/edit/submitted`,
    EasyPayStopPage: `${matchedPath}/easy-pay/stop`,
    EasyPayStopSuccessPage: `${matchedPath}/easy-pay/stop/success`
  }

  return (
    <Switch>
        <AuthenticatedRoute path={routes.premiumBills} redirectPath={routes.premiumBills} exact>
            <LaunchDarklyDependentContent flagName="useNewPremiumsInformation" fallbackContent={<Error404 />}>
                <PremiumsBills/>
            </LaunchDarklyDependentContent>
        </AuthenticatedRoute>
        <AuthenticatedRoute path={routes.premiumMonthly} redirectPath={routes.premiumMonthly} exact>
            <LaunchDarklyDependentContent flagName="useNewPremiumsInformation" fallbackContent={<Error404 />}>
                <PremiumsMonthly/>
            </LaunchDarklyDependentContent>
        </AuthenticatedRoute>
        <AuthenticatedRoute path={routes.EasyPaySignupSubmitted} redirectPath={routes.EasyPaySignupSubmitted} exact>
            <LaunchDarklyDependentContent flagName="useNewPremiumsEasyPay" fallbackContent={<Error404 />}>
                <EasyPaySignupSubmitted/>
            </LaunchDarklyDependentContent>
        </AuthenticatedRoute>
        <AuthenticatedRoute path={routes.EasyPaySignupPage} redirectPath={routes.EasyPaySignupPage} exact>
            <LaunchDarklyDependentContent flagName="useNewPremiumsEasyPay" fallbackContent={<Error404 />}>
                <EasyPaySignupPage/>
            </LaunchDarklyDependentContent>
        </AuthenticatedRoute>
        <AuthenticatedRoute path={routes.EasyPayEditSubmittedPage} redirectPath={routes.EasyPayEditSubmittedPage} exact>
            <LaunchDarklyDependentContent flagName="useNewPremiumsEasyPay" fallbackContent={<Error404 />}>
                <EasyPayEditSubmittedPage/>
            </LaunchDarklyDependentContent>
        </AuthenticatedRoute>
        <AuthenticatedRoute path={routes.EasyPayEditPage} redirectPath={routes.EasyPayEditPage} exact>
            <LaunchDarklyDependentContent flagName="useNewPremiumsEasyPay" fallbackContent={<Error404 />}>
                <EasyPayEditPage/>
            </LaunchDarklyDependentContent>
        </AuthenticatedRoute>
        <AuthenticatedRoute path={routes.EasyPayStopSuccessPage} redirectPath={routes.EasyPayStopSuccessPage} exact>
            <LaunchDarklyDependentContent flagName="useNewPremiumsEasyPay" fallbackContent={<Error404 />}>
                <EasyPayStopSuccessPage/>
            </LaunchDarklyDependentContent>
        </AuthenticatedRoute>
        <AuthenticatedRoute path={routes.EasyPayStopPage} redirectPath={routes.EasyPayStopPage} exact>
            <LaunchDarklyDependentContent flagName="useNewPremiumsEasyPay" fallbackContent={<Error404 />}>
                <EasyPayStopPage/>
            </LaunchDarklyDependentContent>
        </AuthenticatedRoute>
        <Route>
            <Error404 />
        </Route>
    </Switch>
  )
}
